import { useMutation, useQuery, UseQueryOptions } from "react-query";
import {
  IArticleSearchResult,
  ISearchArticlesParams,
  UseGetArticlesByLabelsParams,
} from "~/lib/types/article.type";
import {
  getArticlesByLabels,
  getPromotedArticles,
  getUserChatHistories,
  searchZendeskArticles,
  sentEmail,
} from "~/services/zendesk.service";
import { IEmailProps } from "~/lib/types/email.type";
import { IGetChatHistories } from "../../lib/types/chatHistory";

export const queryKey = {
  getArticles: "getArticles",
  getEmail: "getEmail",
  getFeaturedArticles: "getFeaturedArticles",
};

export const useSearchZendeskArticles = (
  params: ISearchArticlesParams,
  options?: Pick<UseQueryOptions<IArticleSearchResult, unknown>, "onSuccess">
) =>
  useQuery(
    [queryKey.getArticles, params],
    () => searchZendeskArticles({ ...params }),
    {
      enabled: !!params.label_names || !!params.query,
      ...options,
    }
  );

export const mutateSearchZendeskArticles = () =>
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useMutation((data: ISearchArticlesParams) => searchZendeskArticles(data));

export const useSentEmail = () =>
  useMutation((payload: IEmailProps) => sentEmail(payload));

export const getPromotedArticlesQuery = (locale?: string) => ({
  queryKey: [queryKey.getFeaturedArticles, 200, locale],
  queryFn: () => getPromotedArticles(200, locale),
});

export const usePromotedArticles = (locale?: string) =>
  useQuery(getPromotedArticlesQuery(locale));

export const useIndexChatHistories = (params?: IGetChatHistories) =>
  useQuery(["LIST_CHAT_HISTORY", params], () => getUserChatHistories(params));

export const useGetArticlesByLabels = (
  params: UseGetArticlesByLabelsParams
) => {
  return useQuery(["get-articles-by-labels", params.labels, params], () =>
    getArticlesByLabels(params)
  );
};
